/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiReport,
    ApiReportFromJSON,
    ApiReportFromJSONTyped,
    ApiReportToJSON,
} from './ApiReport';

/**
 * 
 * @export
 * @interface ApiResultOfMapOfstringAndApiReport
 */
export interface ApiResultOfMapOfstringAndApiReport {
    /**
     * 
     * @type {{ [key: string]: ApiReport; }}
     * @memberof ApiResultOfMapOfstringAndApiReport
     */
    data?: { [key: string]: ApiReport; };
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndApiReport
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndApiReport
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndApiReport
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndApiReport
     */
    result?: ApiResultOfMapOfstringAndApiReportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfstringAndApiReportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfstringAndApiReportFromJSON(json: any): ApiResultOfMapOfstringAndApiReport {
    return ApiResultOfMapOfstringAndApiReportFromJSONTyped(json, false);
}

export function ApiResultOfMapOfstringAndApiReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfstringAndApiReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (mapValues(json['data'], ApiReportFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfstringAndApiReportToJSON(value?: ApiResultOfMapOfstringAndApiReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (mapValues(value.data, ApiReportToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

